"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(_ref) {
  var visualize = _ref.visualize,
    settings = _ref.settings;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: settings && settings["class"] ? settings["class"] : 'btn btn-primary',
    onClick: visualize
  }, settings && settings.text ? settings.text : 'Visualize');
};